






































import AppLayout from '@/Layouts/AppLayout.vue'
import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';
import FormNavigationButton from '@/Components/FormNavigation/FormNavigationButton.vue';
import ajax from '@/utils/ajax';
import EdelmanLogo from '@/Components/EdelmanLogo.vue';

@Component({
    components: {
        EdelmanLogo,
        FormNavigationButton,
        AppLayout,
    },
})
export default class Dashboard extends Vue {
    @Prop({type: Array, required: true}) sections!: { name: string, progress: number }[]

    handleNavigation(section: string, page: number) {
        const url: string = this.route('form', {
            section,
            page,
        });

        this.$inertia.visit(url)
    }

    async handleClearProgress() {
        const {isConfirmed} = await this.$swal.fire({
            title: 'Clear progress?',
            text: 'All answers will be deleted.  This action is not reversible!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Clear form',
        })

        if (isConfirmed) {
            await ajax.delete(this.route('form--clear'));

            this.$inertia.visit(this.route('dashboard'));
        }
    }
}
